<template>
  <v-container class="pa-6">
    <div class="mb-6">
      <div class="component-title">Báo cáo sale</div>
    </div>

    <v-row>
      <v-col cols="4">
        <AllStatusReport :statusCount="statusCount" :users="users" @selected="selected" />
      </v-col>
      <v-col cols="8">
        <BarLeadReport :statusCount="statusCount" :users="users" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import BarLeadReport from './BarLeadReport.vue'
import AllStatusReport from './AllStatusReport.vue'
export default {
  data() {
    return {
      profile: {},
      filterQuery: {},
      products: [],
      roles: [],
      users: [],
      statusCount: {
        countAll: 0,
        countNoContact: 0,
        countAppointmentSet: 0,
        countProductVerified: 0,
        countSucceed: 0,
        countFailed: 0
      },
      items: [
        {
          text: 'Danh sách nhân viên',
          disabled: false,
          href: '/admin/sale'
        },
        {
          text: 'Thông tin cá nhân',
          disabled: false
        }
      ]
    }
  },
  components: {
    BarLeadReport,
    AllStatusReport
  },
  mounted() {
    this.leadCount()
    this.getUsers()
  },
  computed: {
    ...mapGetters('auth', ['user'])
  },
  methods: {
    ...mapActions('lead', ['countStatus']),
    ...mapActions('user', ['fetchUsers']),
    async leadCount(query) {
      this.$loading.active = true

      const queryParameters = this.user.role.type !== 'admin' ? {...query, inCharge: this.user.id} : query

      this.statusCount = await this.countStatus(queryParameters)

      this.$loading.active = false
    },
    async getUsers(query) {
      if (this.user.role.type === 'admin') {
        const users = await this.fetchUsers({'role_in': ['682d7c93f9f6e40d0ab0324e', '6569abe679c575d1488858f2'], ...query})
        this.users = users
      } else {
        this.users.push(this.user)
      }
    },
    async selected(data) {
      this.filterQuery.inCharge = data
      await this.leadCount(this.filterQuery)
    }
  }
}
</script>

<style>
.v-breadcrumbs__divider {
  padding: 0 !important;
}
</style>
<style scoped>
.component-title {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  color: #0d47a1;
}
</style>
